import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  ListItem,
  ListItemText,
  List,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";
import imgBanner from "../../assets/img/fav_img.png";
import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
// import AllMediaModelApp from "./AllMediaShow";
// import { getAllJob } from "../Jobhiringpost/jobsApi";
// import {
//   applyForJob,
//   getAllJobsMarketplace,
//   getJobProfile,
// } from "./jobListApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getAllJob } from "../Jobhiringpost/jobsApi";
import {
  applyForJob,
  getAllJobsMarketplace,
  getJobProfile,
} from "../Jobs/jobListApi";
import AllMediaModelApp from "../Jobs/AllMediaShow";
import { getAllfranchise, intrestedApply } from "./franchiseApi";
// import { getAllJobsMarketplace } from "./jobListApi";
export default function FranchiseDetails() {
  const [job, setJob] = useState(null);
  const { id } = useParams();
  const token = sessionStorage.getItem("smbToken");

  const [hide, setHide] = useState(false);
  const navigate = useNavigate();
  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }
  const payload = {
    billerId: 0,
    searchBrandName: "",
  };

  const getData = () => {
    getAllfranchise(payload, (data) => {
      const list = data?.data?.data?.list || [];

      const selected = list.find(
        (item) => String(item?.franchise?.id) === String(id),
      );

      // console.log("Courses- ", data.data.data.list);
      setJob(selected);
    });
  };
  useEffect(() => {
    getData();
  }, [id]);

  const applyIntrested = (id) => {
    if (!token) {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      return;
    }

    intrestedApply({ franchiseId: id }).then(() => {
      getData();
    });
  };

  console.log("hhhh", job);

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 1, md: 3, xs: 0 } }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/franchiseList")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            {/* topcard */}
            <Grid container spacing={3} alignItems="stretch">
              {/* img */}
              <Grid item xs={12} sm={3}>
                {/* {job?.images?.[0]?.image ? (
                    <Box
                      component="img"
                      src={job.images[0].image}
                      // alt="Preview"
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 300,
                        height: 300,
                        borderRadius: 2,
                        backgroundColor: "grey.200",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "grey.500",
                        fontSize: 14,
                      }}
                    >
                      No Image
                    </Box>
                  )} */}

                <Box
                  sx={{
                    height: "100%",
                    minHeight: 250,
                    maxHeight: 320,
                    overflow: "hidden",
                    borderRadius: 3,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  <Box
                    component="img"
                    src={job?.images[0]?.image}
                    // alt="Preview"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>

              {/* card */}
              <Grid item xs={12} sm={9} sx={{ display: "flex" }}>
  <Box
    sx={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      p: 3,
      boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    {/* Top section */}
    <Grid container spacing={3} alignItems="center">
      
      {/* Logo */}
      <Grid item xs={12} sm={3}>
        <Box
          component="img"
          src={job?.franchise?.logo}
          sx={{
            width: "100%",
            maxWidth: 180,
            height: 150,
            objectFit: "cover",
            borderRadius: 2,
          }}
        />
      </Grid>

      {/* Details */}
      <Grid item xs={12} sm={9}>
        <Typography
          sx={{
            fontSize: { xs: 18, sm: 22, md: 30 },
            fontWeight: 600,
            wordBreak: "break-word",
          }}
        >
          {job?.franchise?.brandName}
        </Typography>

        <Typography fontWeight={600}>Company Name</Typography>
        <Typography sx={{ wordBreak: "break-word" }}>
          {job?.franchise?.companyName || "-"}
        </Typography>

        <Typography fontWeight={600} mt={1}>
          Franchise Title
        </Typography>
        <Typography sx={{ wordBreak: "break-word" }}>
          {job?.requirements?.[0]?.title || "-"}
        </Typography>

        <Typography fontWeight={600} mt={1}>
          Franchise Territory
        </Typography>
        <Typography sx={{ wordBreak: "break-word" }}>
          {job?.requirements?.[0]?.territory || "-"}
        </Typography>
      </Grid>
    </Grid>

    {/* Buttons */}
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Button
        fullWidth
        variant="outlined"
        onClick={() => setHide(true)}
        sx={{
          fontWeight: 600,
          color: "#01008B",
          borderRadius: "6px",
        }}
      >
        Social Media Links
      </Button>

      <Button
        fullWidth
        variant="contained"
        onClick={() => applyIntrested(job?.franchise?.id)}
        sx={{
          backgroundColor:
            job?.hasApplied !== true ? "#01008B" : "green",
          borderRadius: "6px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0201b3" },
        }}
      >
        {job?.hasApplied && (
          <CheckCircleIcon sx={{ fontSize: 20, mr: 1 }} />
        )}
        {job?.hasApplied !== true ? "Apply" : "Applied"}
      </Button>
    </Box>
  </Box>
</Grid>
            </Grid>

            {/* .Franchise Requirement  */}
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  background:
                    "linear-gradient(90deg, #21209A 0%, rgba(215, 215, 255, 0) 100%)",
                  padding: "10px 15px",
                  mt: { sm: "10px", xs: "1px" },
                  borderRadius: "5px",
                  color: "#ffff", // optional text color
                  textAlign: "left",
                  marginBottom: "0px",
                  fontFamily: "'Montserrat', sans-serif",
                  // fontSize: { xs: "14px", sm: "16px", md: "20px" },

                  fontWeight: 500,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "20px" },
                  }}
                >
                  Franchise Requirement
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Infrastructure */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Infrastructure
                  </Typography>

                  {/* {job?.requirements[0]?.infrastructure[0]?.value} */}

                  {job?.requirements?.[0]?.infrastructure?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.requirements?.[0]?.infrastructure?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}

                  {/*  Investment Cost */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Investment Cost
                  </Typography>
                  {job?.requirements?.[0]?.investmentCosts?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.requirements?.[0]?.investmentCosts?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}

                  {/* Royality */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Royality{" "}
                  </Typography>
                  {job?.requirements?.[0]?.royalties?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.requirements?.[0]?.royalties?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}

                  {/* Staff */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Staff
                  </Typography>
                  {job?.requirements?.[0]?.staff?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.requirements?.[0]?.staff?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* .Franchise Support  */}
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  background:
                    "linear-gradient(90deg, #21209A 0%, rgba(215, 215, 255, 0) 100%)",
                  padding: "10px 15px",
                  mt: { sm: "10px", xs: "1px" },
                  borderRadius: "5px",
                  color: "#ffff", // optional text color
                  textAlign: "left",
                  // marginBottom: "20px",
                  fontFamily: "'Montserrat', sans-serif",
                  // fontSize: { xs: "14px", sm: "16px", md: "20px" },

                  fontWeight: 500,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "20px" },
                  }}
                >
                  Franchise Support
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* JFranchise will provide you */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Franchise will provide you
                  </Typography>
                  {job?.supports?.[0]?.willProvide?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.supports?.[0]?.willProvide?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}
                  {/* ROI & Profit */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    ROI & Profit
                  </Typography>
                  {job?.supports?.[0]?.roIs?.length ? (
                    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
                      {job?.supports?.[0]?.roIs?.map((item) => (
                        <ListItem
                          key={item.id}
                          sx={{ display: "list-item", p: 0 }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "13px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 500,
                                }}
                              >
                                {item.value}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                      -
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
            {/* .Contact Details  */}
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  background:
                    "linear-gradient(90deg, #21209A 0%, rgba(215, 215, 255, 0) 100%)",
                  padding: "10px 15px",
                  mt: { sm: "10px", xs: "1px" },
                  borderRadius: "5px",
                  color: "#ffff", // optional text color
                  textAlign: "left",
                  // marginBottom: "20px",
                  fontFamily: "'Montserrat', sans-serif",
                  // fontSize: { xs: "14px", sm: "16px", md: "20px" },

                  fontWeight: 500,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "20px" },
                  }}
                >
                  Contact Details
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Mobile Number */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.mobileNumber1 || "-"}
                  </Typography>

                  {/* Mobile Number */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.mobileNumber2 || "-"}
                  </Typography>

                  {/* Whatsapp Mobile Number */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Whatsapp Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.whatsappNumber || "-"}
                  </Typography>
                  {/* ........... */}
                  {/* Email Id */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Email Id
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.emailId1 || "-"}
                  </Typography>

                  {/* Email Id2*/}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Email Id
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.emailId2 || "-"}
                  </Typography>

                  {/* Address  */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    Address
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.briefAddress || "-"}
                  </Typography>
                  {/*City  */}
                  <Typography fontWeight={600} fontSize={{ sm: "18px", xs: '16px' }} mb={0.5}>
                    City
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.franchise?.city || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <AllMediaModelApp
              open={hide}
              setOpen={setHide}
              modelData={{
                google: "",
                website: "",
                instagram: "",
                facebook: "",
                youTube: "",
                pinterest: "",
                twitter: "",
                linkedIn: "",
                ...job?.franchise,
              }}
            // setModalData={setMyBussinessData}
            />
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
